/* eslint-disable rxjs/no-subject-value */
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject, Subscription } from 'rxjs';
import { first } from 'rxjs/operators';

@Injectable({
	providedIn: 'root'
})
export class QuestionSelectService {
	private readonly _active$ = new BehaviorSubject(false);
	private readonly _selected$ = new Subject<string>();
	private readonly _highlight$ = new BehaviorSubject<string[]>([]);
	
	public get highlight$(): Observable<string[]> {
		return this._highlight$.asObservable();
	}
	
	public get active$(): Observable<boolean> {
		return this._active$.asObservable();
	}
	
	public selected(key: string): void {
		this._selected$.next(key);
	}
	
	public select(): Observable<string> {
		return new Observable<string>((observer) => {
			this._active$.next(true);
			
			const subscription = this._selected$.pipe(
				first(),
			).subscribe(observer);
			
			subscription.add(() => this._active$.next(false));
			
			return subscription;
		});
	}
	
	public highlight(key: string): Subscription {
		this._highlight$.next([...this._highlight$.value, key]);
		
		return new Subscription(
			() => this._highlight$.next(this._highlight$.value.filter(h => h !== key)),
		);
	}
}
